export const PAYPAL_ENV = process.env.VUE_APP_PAYPAL_ENV ? process.env.VUE_APP_PAYPAL_ENV : 'sandbox';



// WEBPACK FOOTER //
// ./src/config/_paypal.js